import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { RequestService } from 'src/app/services/requests.service';
import { AgGridAngular } from 'ag-grid-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { NgxFileDropEntry, FileSystemDirectoryEntry, FileSystemFileEntry } from 'ngx-file-drop';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dataset',
  templateUrl: './dataset.component.html',
  styleUrls: ['./dataset.component.scss']
})
export class DatasetComponent implements OnInit {

  public id = history.state.id;
  public type: any;
  public selected: boolean = false;
  public gridApi: any;
  public gridColumnApi: any;
  public rowData: any[];
  public columnDefs: ColDef[] = [
    { field: '#', headerName: '#' },
    { field: 'file_name', headerName: "File Name" }
  ];

  public defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
    filterParams: {
      buttons: ['reset', 'apply'],
      filterOptions: ["contains", "notContains"]
    },
  }

  public gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'single',
  }
  public fileId: any;
  public droppedFile: any;
  public uploadedFiles: any[] = [];
  public files: NgxFileDropEntry[] = [];
  public filePublic: any;
  public countries: any[] = [];
  public datasetId: any;
  public fileName: any;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(private req: RequestService<any>, private route: ActivatedRoute, private dialog: MatDialog) { }

  ngOnInit(): void { 
    this.id = history.state.id || this.route.snapshot.paramMap.get('id');
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.getExperiments();
  }

  getExperiments() {
    this.req.getDataset(this.id).subscribe((res) => {
      const rowData = res.experiments.map((experiment, index) => ({
        '#': `Experiment ${(index + 1)}`,
        file_name: experiment.file_name,
        file_id: experiment.file_id
      }));

      this.rowData = rowData;
    });
  }

  onRowClick(e) {
    var selectedRow = this.gridApi.getSelectedRows(e);
    this.fileId = selectedRow[0].file_id;
    this.fileName = selectedRow[0].file_name;
    this.selected = true;
  }

  getFile() {
    const fileUrl = environment.apiType + '://' + environment.apiUrl + '/api/download/' + this.fileId;
    window.open(fileUrl, '_blank');
  }

  upload(uploadRef: TemplateRef<any>) {
    this.dialog.open(uploadRef);
  }

  dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (this.droppedFile of files) {
      if (
        this.droppedFile.fileEntry.name.includes('.pdf') ||
        this.droppedFile.fileEntry.name.includes('.csv') ||
        this.droppedFile.fileEntry.name.includes('.xlsx') ||
        this.droppedFile.fileEntry.name.includes('.doc')
      ) {
      } else {
        const fileEntry = this.droppedFile.fileEntry as FileSystemDirectoryEntry;
        Swal.fire(
          'Incorrect file Format!',
          'You can upload only: Pdf , Csv, Excel or Word files!',
          'error'
        );
      }
    }
  }

  deleteDropped(event: any) {
    let nameUploadedfile = event.srcElement.parentElement.innerText.trim();
    const indexToDelete = this.files.findIndex(
      (item) => item.fileEntry.name === nameUploadedfile
    );
    if (indexToDelete !== -1) {
      this.files.splice(indexToDelete, 1);
    } else {
      this.files = [];
      this.droppedFile = [];
    }
  }

  submitUpload() {
    if (this.files.length == 0) {
      this.files = [];
    } else if (this.files.length > 0) {
      this.files.forEach((element) => {
        if (
          element.fileEntry.name.includes('.pdf') ||
          element.fileEntry.name.includes('.csv') ||
          element.fileEntry.name.includes('.xlsx') ||
          element.fileEntry.name.includes('.doc')
        ) {
          const fileEntry = element.fileEntry as FileSystemFileEntry;
          fileEntry.file((file: File) => {
            this.filePublic = file;
            const formData = new FormData();
            formData.append('dataset_id', this.id);
            formData.append('files', file);
            this.req.postFile(formData).subscribe((res) => {
              console.log(res);
            });
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Success',
              text: 'Successfully Submited',
              showConfirmButton: false,
              timer: 2800,
              customClass: {
                popup: 'success-msg',
              },
              showClass: {
                popup: 'animate__animated animate__fadeInDown',
              },
              hideClass: {
                popup: 'animate__animated animate__fadeOutUp',
              },
            });
          });
        }
      });

      this.files = [];
    }
    this.getExperiments();

  }

}
